import { render, staticRenderFns } from "./gdpr-legal-document-template-view.vue?vue&type=template&id=9fe3a514"
import script from "./gdpr-legal-document-template-view.vue?vue&type=script&lang=js"
export * from "./gdpr-legal-document-template-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports